<template>
  <div class="pb-12 md:pb-32">
    <SearchArea />
    <div class="main-container md:bg-smoke-100 rounded-lg">
      <div class="cart-view bg-smoke-100 rounded-lg">
        <div class="border-b border-dark-b">
          <h2 class="text-xl md:text-2xl font-medium mr-6">Shopping Cart</h2>
        </div>
        <div class="pt-12">
          <CartProductsTable v-if="cartProducts.length" :products="cartProducts" />
          <div v-else class="pt-6">
            <span class="opacity-50">There is no product in your cart.</span>
            <router-link to="/search" class="text-blue opacity-100">
              Click here
            </router-link>
            <span class="opacity-50">to shop</span>
          </div>
        </div>
        <div class="lg:flex justify-between pt-3">
          <div class="cart-info-details lg:pr-10">
            <div class="details-box">
              <h4>Referral Code</h4>
              <div class="md:flex pt-5">
                <input
                  class="rounded-full border border-dark-b py-2 px-3"
                  placeholder="Referral Code..."
                  v-model="referralCode"
                >
                <div class="pt-5 md:pt-0 md:pl-5">
                  <button
                    class="bg-dark-b px-8 py-1 rounded-full text-opacity-50 font-medium text-xl"
                    @click="applyReferralCode"
                  >
                    Apply
                  </button>
                </div>
              </div>
              <div class="px-3 pt-2 md:h-5 flex items-center">
                <span v-if="getReferralCode" class="text-green-700">
                  {{ getReferralCode.message }}
                </span>
                <span v-else-if="response" class="text-danger">
                  {{ response.message }}
                </span>
                <i
                  v-if="showMessage"
                  class="material-icons cursor-pointer"
                  @click="removeCode"
                >close</i>
              </div>
            </div>
            <div class="details-box my-5">
              <h4>Accepted Payment Methods</h4>
              <div class="pt-5 text-sm text-dark">
                <img src="@/assets/images/stripeBadge.png" class="-mx-2 md:-mx-3">
                <p class="pt-3 text-xs">
                  Stripe has been audited by a PCI-certified auditor and is certified to PCI Service Provider Level 1. This is the most stringent level of certification available in the payments industry. Learn more about security at Stripe
                  <a
                    href="https://stripe.com/docs/security/stripe"
                    target="_blank"
                    class="text-blue"
                  >here.</a>
                </p>
              </div>
            </div>
          </div>
          <div class="cart-summary">
            <div
              v-if="cartProducts.length"
              class="p-5 pb-7.5 bg-white rounded-lg border border-dark-b"
            >
              <h4 class="text-xl font-semibold">Order Summary</h4>
              <div class="flex justify-between pt-5">
                <span>Price component</span><span>{{ subTotal | currency }}</span>
              </div>
              <div class="flex justify-between pt-2.5 pb-5 border-b border-dark-b">
                <span>No of Item(s)</span><span>{{ cartProducts.length }}</span>
              </div>
              <div class="flex justify-between pt-5 pb-10 font-semibold">
                <span>Total</span><span>{{ subTotal | currency }}</span>
              </div>
              <router-link
                to="/checkout"
                class="new-app-btn w-full block bg-blue text-xl text-center font-semibold"
              >
                Checkout
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SearchArea from '@/shared/components/layout/SearchArea'
import ProductDetails from '@/shared/mixins/ProductDetails'
import CartProductsTable from '@/shared/components/cart/CartProductsTable'

export default {
  name: 'Cart',
  mixins: [ ProductDetails ],
  beforeRouteEnter: async (to, from, next) => {
      document.title = to.meta.title || 'eCommerce: Self Service Sourcing'
    next()
  },
  components: { SearchArea, CartProductsTable },
  data() {
    return {
      referralCode: '',
      response: null
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn',
      'getGuestCart',
      'getUserCart',
      'getReferralCode'
    ]),
    cartProducts() {
      return this.isUserLoggedIn
        ? [...this.getUserCart]
        : [...this.getGuestCart] 
    },
    showMessage() {
      return !!this.getReferralCode || !!this.response
    }
  },
  methods: {
    ...mapActions ([
      'checkReferralCode',
      'referralCodeApplied',
      'removeReferralCode'
    ]),
    async applyReferralCode() {
      if (this.getReferralCode) {
        this.removeReferralCode()
      }
      this.response = await this.checkReferralCode({referral_code: this.referralCode})
      if (this.response.result) {
        this.referralCodeApplied(this.response)
      }
      this.referralCode = ''
    },
    removeCode() {
      this.response = null
      this.removeReferralCode()
    }
  }
}
</script>
<style lang="scss" scoped>
  .cart-view {
    @apply p-5 mx-auto;
    @screen lg { @apply p-12 };
    @screen xl { @apply px-0; max-width: 1160px; }
    .cart-summary {
      @screen lg { @apply w-80 }
    }
    .cart-info-details {
      @screen lg { max-width: calc(100% - 320px) }
      .details-box {
        @apply p-5 border border-dark-b bg-white rounded-lg;
        h4 {
          @apply text-lg font-semibold tracking-tight;
          @screen md { @apply text-xl tracking-normal; }
        }
      }
    }
  }
</style>